import React, { useEffect, useRef, useState } from 'react';
import { AssignmentModel, AssignmentStatus, TreatmentType } from '../models/superbit-api-models';
import { Select, TimePicker  } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import './_AssignmentConfigPopUp.css';

type Props = {
    ClosePopup?: Function;
    OnApprove?: Function;
    config?: any;
    messageTitle?: string;
};

const ClientTreatmentConfigPopup = (props: Props) => {
    const customerModel = new CustomerCardModel();
    const [statuses, setStatuses] = useState<any[]>([]);
    const [templates, setTemplates] = useState<any[]>([]);
    const [tab, setTab] = useState<string>('Statuses');
    const [newStatusName, setNewStatusName] = useState<string>('');
    const [newTemplateName, setNewTemplateName] = useState<string>('');
    const [newTemplateText, setNewTemplateText] = useState<string>('');

    const loadData = async() => {
        const statusesData = await customerModel.getAssignmentStatuses();
        const templatesData = await customerModel.getAssignmentTemplates();
        const sData = prepareData(statusesData);
        setStatuses(sData);
        setTemplates(templatesData);
    }

    const prepareData = (statuses: any[]) => {
        let systemStatuses = statuses.filter((s: any) => s.isLock).sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
        let notSystemStatuses = statuses.filter((s: any) => !s.isLock).sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);

        console.log('systemStatuses', systemStatuses, 'notSystemStatuses', notSystemStatuses);
        return [
            ...notSystemStatuses,
            ...systemStatuses
        ]
    }

    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
         }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }
    
    const selectTab = (tabName: string) => {
        setTab(tabName);
    }

    const onNewStatusNameChange = (e: any) => {
        const newName = e.target.value;
        setNewStatusName(newName);
    }

    const onAddStatus = async() => {
        if (newStatusName !== '') {
            const response = await customerModel.addAssignmentStatus({
                Name: newStatusName
            });
            loadData();
            setNewStatusName('');
        }
    }

    const onDeleteStatus = async(id: string) => {
        if (id !== '') {
            await customerModel.deleteAssignmentStatus(id);
            loadData();
        }
    }

    const onNewTemplateNameChange = (e: any) => {
        const newName = e.target.value;
        setNewTemplateName(newName);
    }

    const onNewTemplateTextChange = (e: any) => {
        const newText = e.target.value;
        setNewTemplateText(newText);
    }
    
    const onAddTemplate = async() => {
        if (newTemplateName !== '') {
            await customerModel.addAssignmentTemplate({
                Name: newTemplateName,
                Text: newTemplateText
            });
            loadData();
            setNewTemplateName('');
            setNewTemplateText('');
        }
    }

    const onDeleteTemplate = async(id: string) => {
        // return;
        if (id !== '') {
            await customerModel.deleteAssignmentTemplate(id);
            loadData();
        }
    }

    // setNewTemplateText

    const emptyFunc = () => {}

    useEffect(()=>{
        loadData();
    },[])
    
      return ( <>
        <div className={`popup-wrapper assignment-config-popup small-config`}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="clients-tabs-client-card-tabs client-details-view" style={{flexGrow: 1, maxWidth: '400px'}}>
                            <div className={`client-card-tab pointer ${tab == 'Template' ? 'selected' : ''}`} onClick={()=>selectTab('Template')}>
                                <div className="label">
                                    תבנית
                                </div>
                                <div className="under-line"></div>
                            </div>
                            <div className={`client-card-tab pointer ${tab == 'Statuses' ? 'selected' : ''}`} onClick={()=>selectTab('Statuses')}>
                                <div className="label">
                                    סטטוסים
                                </div>
                                <div className="under-line"></div>
                            </div>
                        </div>
                        <div className={`client-tab-content client-details-edit-mode ${tab == 'Template' ? '' : 'hide'}`} style={{width: '100%'}}>
                            <div style={{flexGrow: 1,maxWidth: '90%'}}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`} style={{width: '35%'}}>
                                        <div className="field">
                                            <div className="title">
                                            שם תבנית:
                                            </div>
                                            <div className="value">
                                                <input type='text' value={newTemplateName} onChange={onNewTemplateNameChange} />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`parameter-item`} style={{width: '50%'}}>
                                        <div className="field">
                                            <div className="title">
                                            תוכן תבנית:
                                            </div>
                                            <div className="value">
                                                <textarea rows={2} value={newTemplateText} onChange={onNewTemplateTextChange} />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div> 
                                    <div style={{paddingTop: '42px', width: '10%'}}>
                                        <button className='button blue flex-centered flex-justify-center' onClick={onAddTemplate}>הוסף</button>
                                    </div>   
                                </div>
                                <div className='content-table'>
                                    {templates && templates.map((aTemplate: any, index) =>{
                                        return (
                                        <div className='item-data-row' key={index}>
                                            <div className='cell' style={{minWidth: '150px'}}>{aTemplate.name} </div>
                                            <div className='cell' style={{minWidth: '260px'}}>{aTemplate.text}</div>
                                            <div className='cell item-actions pointer'>
                                                <FontAwesomeIcon className='pointer' icon={faTrash} onClick={()=>onDeleteTemplate(aTemplate.id)} />
                                            </div>
                                        </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className={`client-tab-content client-details-edit-mode ${tab == 'Statuses' ? '' : 'hide'}`}>
                            <div style={{flexGrow: 1, maxWidth: '400px'}}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            שם סטטוס:
                                            </div>
                                            <div className="value">
                                                <input type='text' value={newStatusName} onChange={onNewStatusNameChange} />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{paddingTop: '42px'}}>
                                        <button className='button blue flex-centered flex-justify-center' onClick={onAddStatus}>הוסף</button>
                                    </div>  
                                </div>
                                <div className='content-table'>
                                {statuses && statuses.map((aStatus: any, index) =>{
                                    return (
                                    <div className='item-data-row' key={index}>
                                        <div className='cell'>{aStatus.name}</div>
                                        <div className='cell item-actions pointer'>
                                            {
                                                !aStatus.isLock && 
                                                <FontAwesomeIcon className='pointer' icon={faTrash} onClick={()=>onDeleteStatus(aStatus.id)} />
                                            }
                                        </div>
                                    </div>
                                    )
                                })}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className="button white blue-border pointer"  onClick={(e:any)=>closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    // }
  }
  export default ClientTreatmentConfigPopup;